import { handleActions } from "redux-actions";
import { api } from "api";
import Swal from "sweetalert2";
import moment from "moment/moment";
import { ToastStore } from "react-toasts";

const endpoint = "ventas/reporte_historial_precios";
const endpoint_grafica = "ventas/grafica_historial_precios";

//REP_HISTORIAL_PRECIOS : REPORTE HISTORIAL PRECIOS

export const TAB = "REP_HISTORIAL_PRECIOS_TAB";
export const DATA = "REP_HISTORIAL_PRECIOS_DATA";
export const DATA_GRAFICA = "REP_HISTORIAL_PRECIOS_GRAFICA";
export const LOADER = "REP_HISTORIAL_PRECIOS_LOADER";
export const LOADER_GRAFICA = "REP_HISTORIAL_PRECIOS_LOADER_GRAFICA";
export const PAGE = "REP_HISTORIAL_PRECIOS_PAGE";
export const SUCURSAL = "REP_HISTORIAL_PRECIOS_SUCURSAL";
export const PRODUCTO = "REP_HISTORIAL_PRECIOS_PRODUCTO";
export const FRACCION = "REP_HISTORIAL_PRECIOS_FRACCION";
export const SORT = "REP_HISTORIAL_PRECIOS_SORT";
export const FECHA_INICIAL = "REP_HISTORIAL_PRECIOS_FECHA_INICIAL";
export const FECHA_FINAL = "REP_HISTORIAL_PRECIOS_FECHA_FINAL";
export const ESTADO_DESCARGA = "REP_HISTORIAL_PRECIOS_ESTADO_DESCARGA";

// ------------------------------------
// Actions
// ------------------------------------
export const listar = (page = 1) => (dispatch, getStore) => {
    dispatch(setLoader(true));
    const store = getStore();

    const fecha_inicial = store.reporte_historial_precios.fecha_inicial;
    const fecha_final = store.reporte_historial_precios.fecha_final;
    let params = { page, fecha_inicial, fecha_final };
    const sucursal = store.reporte_historial_precios.sucursal;
    const fraccion = store.reporte_historial_precios.fraccion;
    const producto = store.reporte_historial_precios.producto;
    params.tipo = store.reporte_historial_precios.tab;
    params.ordering = store.reporte_historial_precios.ordering;

    if (fraccion) params.fraccion = fraccion.id;
    if (producto) params.producto = producto.id;
    if (sucursal) params.sucursal_rep = sucursal.id;

    if (sucursal && producto && fraccion) {
        api.get(`${endpoint}`, params)
            .catch((err) => {
                Swal("ERROR", "Ha ocurrido un error.", "error");
            })
            .then((resp) => {
                if (resp) {
                    dispatch(setData(resp));
                    dispatch(setPage(page));
                    dispatch(dataGraficaMovimientos());
                }
            })
            .finally(() => {
                dispatch(setLoader(false));
            });
    } else {
        const data = {};
        dispatch(setData(data));
        dispatch(setLoader(false));
    }
};

export const dataGraficaMovimientos = () => (dispatch, getStore) => {
    dispatch(setLoaderGrafica(true));
    const store = getStore();

    const fecha_inicial = store.reporte_historial_precios.fecha_inicial;
    const fecha_final = store.reporte_historial_precios.fecha_final;
    const params = { fecha_inicial, fecha_final };
    const sucursal = store.reporte_historial_precios.sucursal;
    const fraccion = store.reporte_historial_precios.fraccion;
    const producto = store.reporte_historial_precios.producto;

    if (fraccion) params.fraccion = fraccion.id;
    if (producto) params.producto = producto.id;
    if (sucursal) params.sucursal_rep = sucursal.id;

    if (sucursal && producto && fraccion) {
        api.get(`${endpoint_grafica}`, params)
            .then((response) => {
                if (response) dispatch(setDataGrafica(response));
            })
            .catch((error) => {
                Swal("ERROR", "Ha ocurrido un error.", "error");
            })
            .finally(() => {
                dispatch(setLoaderGrafica(false));
            });
    } else {
        dispatch(setDataGrafica(null));
        dispatch(setLoaderGrafica(false));
    }
};

export const setSucursal = (value) => (dispatch, getStore) => {
    dispatch(_setSucursal(value));

    const store = getStore();
    const producto = store.reporte_historial_precios.producto;
    const sucursal = store.reporte_historial_precios.sucursal;
    const fraccion = store.reporte_historial_precios.fraccion;

    if (producto && sucursal && fraccion) {
        dispatch(listar());
    } else {
        dispatch(setDataGrafica(null));
    }
};

export const setProducto = (value) => (dispatch, getStore) => {
    dispatch(_setProducto(value));
    const store = getStore();
    const producto = store.reporte_historial_precios.producto;
    const sucursal = store.reporte_historial_precios.sucursal;
    const fraccion = store.reporte_historial_precios.fraccion;

    if (producto && sucursal && fraccion) {
        dispatch(listar());
    } else {
        dispatch(setDataGrafica(null));
    }
};
export const setFraccion = (value) => (dispatch, getStore) => {
    dispatch(_setFraccion(value));
    const store = getStore();
    const sucursal = store.reporte_historial_precios.sucursal;
    const producto = store.reporte_historial_precios.producto;
    const fraccion = store.reporte_historial_precios.fraccion;

    if (producto && sucursal && fraccion) {
        dispatch(listar());
    } else {
        dispatch(setDataGrafica(null));
    }
};

export const sortChange = (sortName, sortOrder) => (dispatch, getStore) => {
    if (sortOrder === "asc") {
        dispatch(setSort(sortName));
    } else {
        dispatch(setSort(`-${sortName}`));
    }
    const store = getStore();
    const page = store.reporte_historial_precios.page;
    dispatch(listar(page));
};

export const setFecha = (key, value) => (dispatch, getStore) => {
    const store = getStore();
    const reporte_historial_precios = store.reporte_historial_precios;
    const sucursal = store.reporte_historial_precios.sucursal;
    const producto = store.reporte_historial_precios.producto;
    const fraccion = store.reporte_historial_precios.fraccion;

    if (key === "Inicial") {
        const fecha_inicial = new Date(value);
        const fecha_final = new Date(reporte_historial_precios.fecha_final);
        if (fecha_final >= fecha_inicial) dispatch(setFechaInicial(value));
    } else {
        const fecha_inicial = new Date(reporte_historial_precios.fecha_inicial);
        const fecha_final = new Date(value);
        if (fecha_final >= fecha_inicial) dispatch(setFechaFinal(value));
    }
    if (producto && sucursal && fraccion) {
        dispatch(listar());
    } else {
        dispatch(setDataGrafica(null));
    }
};

export const changeTab = (tab) => (dispatch) => {
    dispatch(setTab(tab));
    dispatch(listar());
};

export const descargarListado = () => (dispatch, getStore) => {
    const store = getStore();
    const fecha_inicial = store.reporte_historial_precios.fecha_inicial;
    const fecha_final = store.reporte_historial_precios.fecha_final;
    let params = { fecha_inicial, fecha_final };
    const sucursal = store.reporte_historial_precios.sucursal;
    const fraccion = store.reporte_historial_precios.fraccion;
    const producto = store.reporte_historial_precios.producto;
    params.tipo = store.reporte_historial_precios.tab;
    params.ordering = store.reporte_historial_precios.ordering;

    if (fraccion) params.fraccion = fraccion.id;
    if (producto) params.producto = producto.id;
    if (sucursal) params.sucursal_rep = sucursal.id;

    dispatch(setEstadoDescarga(true));
    api.get(`ventas/descargar_excel_reporte_historial_precios`, params)
        .catch((err) => {
            Swal(
                "¡Error al descargar!",
                "Ocurrió un error al descargar el archivo. Por favor intenté más tarde.",
                "error"
            );
            dispatch(setEstadoDescarga(false));
        })
        .then((data) => {
            if (data) {
                Swal(
                    "¡Descarga en proceso!",
                    "La descarga comenzará en un momento. Por favor no recargue la página hasta que se haya descargado el archivo",
                    "info"
                );
                dispatch(setEstadoDescarga(true));
                dispatch(esperarDescarga(data.id));
            }
        });
};

const esperarDescarga = (id) => (dispatch) => {
    let intervalPromise;

    //  VOLVER A HACER LA PETICIÓN PARA VERIFICAR QUE YA TERMINO LA DESCARGA

    function listener() {
        api.get("archivos/estado_descarga", { id })
            .catch((err) => {
                let msg =
                    "Ocurrió un error al descargar el archivo. Por favor intenta más tarde";
                if (err.estado) {
                    msg = err.observaciones;
                }
                dispatch(setEstadoDescarga(false));
                clearInterval(intervalPromise);
                Swal("Error al descargar!", msg, "error");
            })
            .then((resp) => {
                if (resp.estado === 10) {
                    // PROCESANDO
                    dispatch(setEstadoDescarga(true));
                } else if (resp.estado === 20) {
                    // TERMINADO
                    clearInterval(intervalPromise);
                    let nombre = resp.archivo
                        ? resp.archivo.split("/media/archivos/")[1]
                        : "Bajas_salidas_por_producto.xlsx";
                    const context = {
                        name: name,
                        url: resp.archivo,
                    };

                    dispatch(setEstadoDescarga(false));
                    dispatch(descargaArchivo(context));
                }
            });
    }

    listener();
    intervalPromise = setInterval(listener, 1000);
};

const descargaArchivo = (context) => (dispatch) => {
    let elem = document.createElement("a");
    elem.href = context.url;
    elem.download = context.name;
    elem.target = "hiddenIframe";
    elem.click();
    dispatch(setEstadoDescarga(false));
    ToastStore.success("Archivo descargado exitosamente");
};

// ------------------------------------
// PureActions
// ------------------------------------
export const setData = (data) => ({
    type: DATA,
    data,
});
export const setDataGrafica = (data_grafica) => ({
    type: DATA_GRAFICA,
    data_grafica,
});
export const setLoader = (loader) => ({
    type: LOADER,
    loader,
});
export const setLoaderGrafica = (loader_grafica) => ({
    type: LOADER_GRAFICA,
    loader_grafica,
});
export const setPage = (page) => ({
    type: PAGE,
    page,
});
export const _setSucursal = (sucursal) => ({
    type: SUCURSAL,
    sucursal,
});
export const _setProducto = (producto) => ({
    type: PRODUCTO,
    producto,
});
export const _setFraccion = (fraccion) => ({
    type: FRACCION,
    fraccion,
});
export const setSort = (ordering) => ({
    type: SORT,
    ordering,
});
export const setFechaInicial = (fecha_inicial) => ({
    type: FECHA_INICIAL,
    fecha_inicial,
});
export const setFechaFinal = (fecha_final) => ({
    type: FECHA_FINAL,
    fecha_final,
});
export const setTab = (tab) => ({
    type: TAB,
    tab,
});
const setEstadoDescarga = (estado_descarga) => ({
    type: ESTADO_DESCARGA,
    estado_descarga,
});

export const actions = {
    setSucursal,
    setProducto,
    setFraccion,
    listar,
    sortChange,
    setFecha,
    changeTab,
    descargarListado,
};

// ------------------------------------
// Reducers
// ------------------------------------
export const reducers = {
    [DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [DATA_GRAFICA]: (state, { data_grafica }) => {
        return {
            ...state,
            data_grafica,
        };
    },
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LOADER_GRAFICA]: (state, { loader_grafica }) => {
        return {
            ...state,
            loader_grafica,
        };
    },
    [PAGE]: (state, { page }) => {
        return {
            ...state,
            page,
        };
    },
    [SUCURSAL]: (state, { sucursal }) => {
        return {
            ...state,
            sucursal,
        };
    },
    [PRODUCTO]: (state, { producto }) => {
        return {
            ...state,
            producto,
        };
    },
    [FRACCION]: (state, { fraccion }) => {
        return {
            ...state,
            fraccion,
        };
    },
    [SORT]: (state, { ordering }) => {
        return {
            ...state,
            ordering,
        };
    },
    [FECHA_INICIAL]: (state, { fecha_inicial }) => {
        return {
            ...state,
            fecha_inicial,
        };
    },
    [FECHA_FINAL]: (state, { fecha_final }) => {
        return {
            ...state,
            fecha_final,
        };
    },
    [TAB]: (state, { tab }) => {
        return {
            ...state,
            tab,
        };
    },
    [ESTADO_DESCARGA]: (state, { estado_descarga }) => {
        return {
            ...state,
            estado_descarga,
        };
    },
};

// ------------------------------------
// InitialState
// ------------------------------------

export const initialState = {
    data: {},
    data_grafica: { ventas: [], compras: [] },
    ordering: "",
    loader: false,
    loader_grafica: false,
    page: 1,
    sucursal: 0,
    fraccion: 0,
    producto: null,
    fecha_inicial: moment().format("YYYY-MM-DD"),
    fecha_final: moment().format("YYYY-MM-DD"),
    tab: 30,
    estado_descarga: false,
};

export default handleActions(reducers, initialState);
